import { getters } from './getters'
import { actions } from './actions'
import { mutations } from './mutations'
import { Item, ModuleState } from './types'

export const initialState: ModuleState = {
  items: [],
  item: {} as Item
}

export const state = initialState

const namespaced = true

export default {
  namespaced,
  state,
  getters,
  actions,
  mutations
}
